module.exports = __webpack_public_path__ + "static/img/IMG_20150310_154524.49aeea0c.jpg";